import { useEffect } from 'react';

import { useStatefulRef } from '../../../hooks/use-stateful-ref';

type UseMenuSizeOptions = {
	gutter?: number;
	minHeight?: number;
};

export const useMenuSize = (options: UseMenuSizeOptions = {}) => {
	const gutter = options.gutter ?? 20;
	const minHeight = options.minHeight ?? 300;
	const [el, setEl] = useStatefulRef<HTMLDivElement>();

	useEffect(() => {
		const listener = () => {
			if (!el) {
				return;
			}

			const rect = el.getBoundingClientRect();
			const vh = window.innerHeight;
			const maxHeight = vh - rect.top - gutter;
			const max = Math.max(maxHeight, minHeight);

			el.style.maxHeight = `${max}px`;
		};

		listener();

		document.addEventListener('scroll', listener);
		window.addEventListener('resize', listener);

		return () => {
			document.removeEventListener('scroll', listener);
			window.removeEventListener('resize', listener);
		};
	}, [el, gutter, minHeight, setEl]);

	return setEl;
};
